import { Component, OnInit,Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Cliente } from 'src/app/interfaces/cliente';
import { Direccion } from 'src/app/interfaces/direccion';
import { ClienteService } from 'src/app/service/cliente.service';
import { DireccionService } from 'src/app/service/direccion.service';

@Component({
  selector: 'app-direccion-form',
  templateUrl: './direccion-form.component.html',
  styleUrls: ['./direccion-form.component.css']
})
export class DireccionFormComponent implements OnInit {
  public direccion: Direccion;
  public cliente:Cliente;
  constructor(private direccionService:DireccionService,private clienteService: ClienteService,private dialogRef: MatDialogRef<DireccionFormComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private dialog: MatDialog) {
    this.cliente={
      email:'',
      password:'',
      token:'',
      estado:0,
      dni:0,
      nombres:''

    }
    this.direccion={id_cliente:0,
      provincia:'',
      localidad:'',
      direccion:'',
      estado:1,
      cp:'',
      piso_dpto:'',
      telefono:0,
      observacion:'',
      nombre:''
   }
  }
  ngOnInit(): void {
    this.clienteService.getbytoken().then((item:Cliente)=>{
      this.cliente=item;
      let id=item.id;

        if(item.id){
          this.direccion.id_cliente=item.id;
          console.log(item);
        }



    });
  }

  enviar(){
    this.direccionService.post(this.direccion).then((item:any)=>{this.dialogRef.close();});
  }

}


